import React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import fileDownload from "../../assets/Icons/file-download.svg";

export const formatKeys = (obj) => {
    const formatted = {};
    for (const key in obj) {
        const formattedKey = key
            .replace(/_/g, ' ')
            .replace(/\w\S*/g, (w) =>
                w?.charAt(0).toUpperCase() + w?.slice(1)?.toLowerCase()
            );
        formatted[formattedKey] = obj?.[key];
    }
    return formatted;
};

function ExcelDownloader({ data = [], fileName = 'data', sheetName = 'Sheet1' }) {
    const handleDownload = () => {
        const isArray = Array.isArray(data);
        const formattedData = isArray
            ? data?.map(formatKeys)
            : [formatKeys(data)];


        const headers = Object.keys(formattedData?.[0]);


        const worksheet = XLSX.utils.aoa_to_sheet([
            headers,
            ...formattedData.map(obj => headers?.map(h => obj[h]))
        ]);


        headers?.forEach((_, idx) => {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: idx });
            if (!worksheet[cellAddress]) return;
            worksheet[cellAddress].s = {
                font: { bold: true }
            };
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
            cellStyles: true
        });

        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `${fileName}.xlsx`);
    };

    return (
        <img
            src={fileDownload}
            alt="Download Excel"
            onClick={handleDownload}
            title="Download Excel"
        />
    );
}

export default ExcelDownloader;

export function formatStringWithSpace(str) {
  if (typeof str !== 'string') return '';
  const spaced = str.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}